import React, { useState, useEffect, useRef } from "react";
import FormattedJSON from "../common/FormattedJSON";
import ContextMenu from "../common/ContextMenu";
import { FaTrash, FaStop, FaCopy } from "react-icons/fa";

const DebugConsole = () => {
  const [output, setOutput] = useState([]);
  const [, setIsDebugging] = useState(false);
  const [contextMenu, setContextMenu] = useState(null);
  const outputRef = useRef(null);

  useEffect(() => {
    const updateState = () => {
      if (window.debuggerState) {
        setOutput(window.debuggerState.output);
        setIsDebugging(window.debuggerState.isDebugging);
      }
    };

    updateState();
    const interval = setInterval(updateState, 1000); // Update every second

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (outputRef.current) {
      outputRef.current.scrollTop = outputRef.current.scrollHeight;
    }
  }, [output]);

  const generateConsoleText = () => {
    return output
      .map((item) => {
        if (item.type === "json") {
          return JSON.stringify(JSON.parse(item.content), null, 2);
        }
        return item.content;
      })
      .join("");
  };

  const handleCopyAll = () => {
    const consoleText = generateConsoleText();
    navigator.clipboard
      .writeText(consoleText)
      .then(() => {
        window.debuggerState.append("Console content copied to clipboard");
      })
      .catch((err) => {
        window.debuggerState.append("Failed to copy console content: " + err);
      });
  };

  const handleContextMenu = (event) => {
    event.preventDefault();
    setContextMenu({
      x: event.clientX,
      y: event.clientY,
    });
  };

  const closeContextMenu = () => {
    setContextMenu(null);
  };

  const handleHaltDebugging = () => {
    if (window.debuggerState.isDebugging) {
      window.dispatchEvent(new CustomEvent("eventStreamUpdate", { detail: { event: "debugging_halted", timestamp: new Date().toISOString() } }));
      window.debuggerState.append("Debugging halted");
    } 
    window.debuggerState.endDebugging();
  };

  const handleClearConsole = () => {
    window.debuggerState.output = [];
  };

  const contextMenuItems = [
    {
      label: "Copy All",
      icon: FaCopy,
      onClick: handleCopyAll,
    },
    {
      label: "Clear Console",
      icon: FaTrash,
      onClick: handleClearConsole,
    },
    {
      label: "Halt Debugging",
      icon: FaStop,
      onClick: handleHaltDebugging,
    },
  ];

  return (
    <div
      className="h-full bg-[#1E1E1E] flex flex-col"
      onContextMenu={handleContextMenu}
    >
      <div
        ref={outputRef}
        className="flex-grow overflow-y-auto p-1.5 font-mono text-xs whitespace-pre-wrap break-word text-gray-300 dark-slim-scrollbar"
      >
        {output.map((item, index) => (
          <React.Fragment key={index}>
            {item.type === "json" ? (
              <FormattedJSON json={item.content} />
            ) : (
              item.content
            )}
          </React.Fragment>
        ))}
      </div>
      {contextMenu && (
        <ContextMenu
          items={contextMenuItems}
          x={contextMenu.x}
          y={contextMenu.y}
          onClose={closeContextMenu}
        />
      )}
    </div>
  );
};

export default DebugConsole;